import React from 'react';

const Footer = () => {
  return (
    <footer className="relative mt-16 md:mt-24">
      {/* Top border with gradient */}
      <div className="h-[2px] w-full bg-gradient-to-r from-cyan-400 via-[#ff00ff] to-cyan-400" />
      
      {/* Footer content */}
      <div className="py-6 md:py-8 px-4">
        <div className="max-w-7xl mx-auto">
          {/* Main footer content */}
          <div className="text-center space-y-3 md:space-y-4">
            {/* Name with cyber decoration */}
            <div className="font-mono text-sm md:text-base">
              <span className="text-green-500">&lt;</span>
              <span className="text-cyan-400">Nagaraj_K</span>
              <span className="text-green-500">/&gt;</span>
            </div>
            
            {/* Copyright text */}
            <p className="text-[#ff00ff] text-xs md:text-sm font-mono">
              &copy; {new Date().getFullYear()} All rights reserved
            </p>

          </div>
        </div>
      </div>

      {/* Decorative corner elements */}
      <div className="absolute top-0 left-0 w-2 h-2 md:w-3 md:h-3 border-l-2 border-t-2 border-cyan-400" />
      <div className="absolute top-0 right-0 w-2 h-2 md:w-3 md:h-3 border-r-2 border-t-2 border-cyan-400" />
      <div className="absolute bottom-0 left-0 w-2 h-2 md:w-3 md:h-3 border-l-2 border-b-2 border-[#ff00ff]" />
      <div className="absolute bottom-0 right-0 w-2 h-2 md:w-3 md:h-3 border-r-2 border-b-2 border-[#ff00ff]" />
    </footer>
  );
};

export default Footer;